'use strict'

export let english_product={
  Overview: {
    fields: {
      summary: {
        help: "Have any major milestones just passed, or are there any in the near future? Are there any resent successes or break throughs? What are currently the main challenges? What is the general health condition?",
        description: "Describe the overall status. Assume the reader has not read the previous report or know any details up front."
      },
      performedAchivements: {
        help: "What type of work was execution or completed this period? Which releases or operational improvements were planned to be completed this period? How did it go? ",
        description: "Describe the work done and the goals achieved this period"

      },
      plannedAchivements: {
        help: "What type of work will be in execution or will be completed the coming period? Which releases or operational improvements are planned to be completed this period?",
        description: "Describe the work to be done and the goals set for the next period"
      },

      benefits: {
        help: "Is the product/platform delivering the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case?",
        description: "Describe to what extent the product is currently delivering the benefits assumed or planned."
      },
      time: {
        help: "What is the latest forecast on completing the planned releases and operational improvements, and how does it compare to the communicated roadmap?",
        description: "Describe how we are doing compared to the roadmap and milestones set and communicated"
      },
      cost: {
        help: "What is the planned running cost for development and maintenance? What is forecasted to be spent short term and long term. What is currently the approved spending?",
        description: "Describe the running cost and how we are doing compared to the planned cost."
      },
  
      quality: {
        help: "Are internal and external customers and users happy with the state of the product? Is functionality, stability, security and reliability good enough?",
        description: "Describe to what extent we currently are meeting customers'/users' expectations to functionality, stability, security, speed and reliability"
      },
      scope: {
        help: "Do we have what we need to promote, sell, deliver and support this product/platform in a good way? Does the product cover the functional domains needed?",
        description: "Describe to what extent the product/platform covers what it needs to cover both in terms of functional domains and operational efficiency"
      },

      risk: {
        help: "What is the current risk level and how is it matching the stakeholders risk appetite or expectations? What are the most important risks and what actions are taken?",
        description: "Describe how the current risk level is compared to the agreed or commonly understood risk appetite"
      }
    }
  },
};



// WEBPACK FOOTER //
// ./views/progress/labels/english_product.js